export default __webpack_public_path__ + "static/media/ic-eye-o-gray.ff8b2961.svg";